import React from 'react'
import cn from 'classnames'
import { Error, Success, Warning } from '@components/icons'

export interface AlertMessageProps {
    type: 'danger' | 'warning' | 'success'
    children: React.ReactNode
}

const AlertMessage = ({
    type,
    children
}: AlertMessageProps): React.ReactElement => {
    return (
        <div className={cn('toast-container', `bg-alert-${type}-toast`)}>
            <div className="toast-content">
                <div className="toast-content-inner">
                    {type === 'danger' ? <Error /> : null}
                    {type === 'warning' ? <Warning /> : null}
                    {type === 'success' ? <Success /> : null}
                    <div className="toast-text">{children}</div>
                </div>
            </div>
        </div>
    )
}

export default AlertMessage
